import { combineReducers } from "redux";
import reducer from "../../features/store/reducer";
/** Start - Academy Related Imports */
import { modalReducer } from "../../features/components/academy/store/model/model.reducer";
import { isoFileManagementReducer } from "../../features/components/academy/iso-file-management/store/iso-file-management.reducer";
import { courseInstanceReducer } from "../../features/components/academy/start-course-instance/store/start-course-instance.reducer";
import { createCourseReducer } from "../../features/components/academy/create-course/store/create-course.reducer";
import { viewCourseReducer } from "../../features/components/academy/view-course/store/view-course.reducer";
import { viewCourseTemplateReducer } from "../../features/components/academy/view-course-templates/store/view-course-template.reducer";
import { fileManagementReducer } from "../../features/components/academy/file-management/store/file-management.reducer";
import { viewDeployedCourseInstanceReducer } from "../../features/components/academy/view-deployed-course-instance/store/vdc-instance.reducer";
/** End - Academy Related Imports */

// New: explicit reducers map (can help avoid some circular issues)
export const reducers = {
  reducer,
  modalReducer,
  isoFileManagementReducer,
  courseInstanceReducer,
  createCourseReducer,
  viewCourseReducer,
  viewCourseTemplateReducer,
  fileManagementReducer,
  viewDeployedCourseInstanceReducer,
};

// Preferred name
export const rootReducer = combineReducers(reducers);

// Backward compatibility (old name)
export const combineReducer = rootReducer;

export type AppState = ReturnType<typeof rootReducer>;

export default rootReducer;
